import { handleErrorApi } from "../../helpers/randoms"
import EstadisticasMiOspedycService from "../../services/EstadisticasMiOspedycService"
import { types } from "../../types/types"
import { finishSpinner, startSpinner } from "../ui/spinner"

export const getEstadisticasGenerales = (fechaDesde="", fechaHasta="") => async (dispatch) => {
    dispatch(startSpinner())
    dispatch({ type: types.estadisticasMiOspedycGeneralesTraerStart })
    try {
        const result = await EstadisticasMiOspedycService.getGenerales(fechaDesde, fechaHasta)
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.estadisticasMiOspedycGeneralesTraerSuccess,
                payload: body
            })
            dispatch(finishSpinner())
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.estadisticasMiOspedycGeneralesTraerError })
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al obtener las estadisticas generales de mi ospedyc", "Ha ocurrido un error. Intente nuevamente")
    }
  }

  export const getEstadisticasUsuarios = () => async (dispatch) => {
    dispatch(startSpinner())
    dispatch({ type: types.estadisticasMiOspedycUsuariosTraerStart })
    try {
        const result = await EstadisticasMiOspedycService.getUsuarios()
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.estadisticasMiOspedycUsuariosTraerSuccess,
                payload: body
            })
            dispatch(finishSpinner())
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.estadisticasMiOspedycUsuariosTraerError })
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al obtener las estadisticas Usuarios de mi ospedyc", "Ha ocurrido un error. Intente nuevamente")
    }
  }

  export const getEstadisticasTurnos = () => async (dispatch) => {
    dispatch(startSpinner())
    dispatch({ type: types.estadisticasMiOspedycTurnosTraerStart })
    try {
        const result = await EstadisticasMiOspedycService.getTurnos()
        const body = await result.json()
        if (result.ok) {
            dispatch({
                type: types.estadisticasMiOspedycTurnosTraerSuccess,
                payload: body
            })
            dispatch(finishSpinner())
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.estadisticasMiOspedycTurnosTraerError })
        dispatch(finishSpinner())
        handleErrorApi(dispatch, error, "Error al obtener las estadisticas Turnos de mi ospedyc", "Ha ocurrido un error. Intente nuevamente")
    }
  }

  export const cargarEstadisticas = (idEstadistica, data={}) => async (dispatch) => {
    try {
        const result = await EstadisticasMiOspedycService.cargar(idEstadistica, data)
        const body = await result.json()
        if (result.ok) {
            //
        } else {
            throw body
        }
    } catch (error) {
        console.log("Ha ocurrido un error al cargar la estadistica de mi Ospeedyc: ", error)
    }
  }

  export const DescargarExcelUsuarios = () => async (dispatch) =>{
      dispatch(startSpinner());
      const url = `${process.env.REACT_APP_API_URL}/ExcelsEstadisticas/EstadisticasUsuarios`;
      const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
    let httpHeaders;
    if (token) {
        httpHeaders = {
            Authorization: `Bearer ${token}`,
        };
    }
    try {
        const result = await fetch(url, {
          method: "GET",
          headers: httpHeaders, 
        });
        const body = await result.blob(); 
        if(result.ok){
          const url = window.URL.createObjectURL(new Blob([body]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PlanillaDatosUsuarios.xlsx');
            document.body.appendChild(link);
            link.click();
          dispatch(finishSpinner());
        }else{
          throw body.errores;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al descargar el archivo", "Ha ocurrido un error. Intente nuevamente")
    }
  }
  export const DescargarExcelGenerales = () => async (dispatch) =>{
    dispatch(startSpinner());
    const url = `${process.env.REACT_APP_API_URL}/ExcelsEstadisticas/EstadisticasGenerales`;
    const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  let httpHeaders;
  if (token) {
      httpHeaders = {
          Authorization: `Bearer ${token}`,
      };
  }
  try {
      const result = await fetch(url, {
        method: "GET",
        headers: httpHeaders, 
      });
      const body = await result.blob(); 
      if(result.ok){
        const url = window.URL.createObjectURL(new Blob([body]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'PlanillaDatosGenerales.xlsx');
          document.body.appendChild(link);
          link.click();
        dispatch(finishSpinner());
      }else{
        throw body.errores;
      }
  } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(dispatch, error, "Error al descargar el archivo", "Ha ocurrido un error. Intente nuevamente")
  }
}